import { useTranslations } from "adapters/i18n";
import React, { type ReactNode } from "react";
import { connect } from "react-redux";
import type { RootState } from "redux/reducers";
import type { Fazenda } from "shared/types";

type StateProps = ReturnType<typeof mapStateToProps>;

type RenderOptions = { noFarmSelectedTitle: string };
type OwnProps = {
  render: (farm: Fazenda | null, options: RenderOptions) => ReactNode;
};

type SelectedFarmContainerProps = StateProps & OwnProps;

export const SelectedFarmContainer = ({
  farm,
  render,
}: SelectedFarmContainerProps) => {
  const { t } = useTranslations();
  const noFarmSelectedTitle = t("common:no-farm-selected").toUpperCase();

  return <>{render(farm, { noFarmSelectedTitle })}</>;
};

const mapStateToProps = (state: RootState) => ({
  farm: state.fazenda.currentFarm,
});

export default connect(mapStateToProps)(SelectedFarmContainer);
